import { Page, LinkButton, ExternalLinkIcon } from '@/components';
import { useSearchParams } from '@/hooks';

import OverviewKpis from './OverviewKpis';
import { Flex } from '@blockanalitica/ui';

export default function SparkLendPage() {
  const [daysAgo] = useSearchParams('days_ago', '1');
  return (
    <Page
      title="Spark Lend"
      actions={
        <>
          <LinkButton
            to="https://spark.blockanalitica.com/v1/ethereum/markets/DAI/"
            target="_blank">
            <Flex
              gap="3xs"
              alignItems="center"
              style={{ whiteSpace: 'nowrap' }}>
              Spark DAI Details
              <ExternalLinkIcon size="1" />
            </Flex>
          </LinkButton>
        </>
      }>
      <OverviewKpis daysAgo={daysAgo} />
    </Page>
  );
}
